import tw, { TwStyle } from 'twin.macro';
import React from 'react';
import Button from '@teetsh/app/src/components/Buttons/Button';
import {
  ExclamationCircleIcon,
  ExclamationTriangleIcon,
} from '@heroicons/react/24/outline';

export type Intent = 'danger' | 'warning';

const intentStyles: { [K in Intent]: { bg: TwStyle; text: TwStyle } } = {
  danger: {
    bg: tw`bg-danger-quiet`,
    text: tw`text-danger-moderate`,
  },
  warning: {
    bg: tw`bg-warning-quiet`,
    text: tw`text-warning-moderate`,
  },
};

const iconComponents: { [K in Intent]: typeof ExclamationCircleIcon } = {
  warning: ExclamationTriangleIcon,
  danger: ExclamationCircleIcon,
};

export function ConfirmationPopoverBody({
  onConfirm,
  onCancel,
  bodyTitle,
  bodyDescription,
  confirmButtonTitle,
  backButtonTitle,
  intent,
}: {
  onConfirm: () => void;
  onCancel?: () => void;
  bodyTitle: string;
  bodyDescription?: React.ReactNode;
  confirmButtonTitle: string;
  backButtonTitle: string;
  intent: Intent;
}) {
  const Icon = iconComponents[intent];

  return (
    <div tw="px-4 py-3">
      <div>
        <div css={[tw`p-1 rounded-lg inline-block`, intentStyles[intent].bg]}>
          <Icon css={[tw`w-5 h-5`, intentStyles[intent].text]} />
        </div>
        <div tw="mt-2">
          <h5>{bodyTitle}</h5>
          {bodyDescription && (
            <p tw="text-neutral-moderate text-sm">{bodyDescription}</p>
          )}
        </div>
      </div>
      <div tw="flex justify-end items-start gap-2 mt-4">
        <Button small intent="none" onClick={onCancel}>
          {backButtonTitle}
        </Button>
        <Button small intent={intent} onClick={onConfirm}>
          {confirmButtonTitle}
        </Button>
      </div>
    </div>
  );
}
